import Select from 'react-select-plus'
import { List, Map } from 'immutable'
import IconSVG from 'svg-inline-react'
import * as cx from 'classnames'

import Avatar from 'shared-web/src/components/Avatar'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import plusIconSrc from '!svg-inline?removeTags=true!images/svg/plus.svg'
import closeIconSrc from '!svg-inline?removeTags=true!images/svg/close.svg'

import './style.styl'

const AvatarOption = (props) => {
  const { option, onSelect, onFocus, isFocused } = props
  const displayName = getDisplayName(option)
  const handleMouseDown = (event) => {
    event.preventDefault()
    event.stopPropagation()
    onSelect(option, event)
  }
  const handleMouseEnter = (event) => {
    onFocus(option, event)
  }
  const handleMouseMove = (event) => {
    if (isFocused) { 
      return
    }
    onFocus(option, event)
  }
  return (
    <div
      className={cx("rep-option", { focused: isFocused })}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      title={displayName}>
      <div title={displayName} style={{ display: 'inline-flex' }}>
        <Avatar key={option.id} user={option} />
        <span>{displayName}</span>
      </div>
    </div>
  )
}

const AvatarValue = (props) => {
  const { value: { value, label }} = props
  return value
    ? <div className="Select-value rep-select" title={label}>
        <span className="Select-value-label">
          <div title={label} style={{ display: 'inline-flex' }}>
            <Avatar key={value.id} user={value} />
            <span>{label}</span>  
          </div>
        </span>
      </div>
    : null
}

const getUsersFromIds = (listOfUserIds, Users) =>
  listOfUserIds.map((userId) => Users[userId])

const setValuesGivenListOfUsers = (listOfUsers) =>
  List(listOfUsers.map((user) => _.get(user, 'id', null)))


const RepSelectContainer = ({ options, onChange, value, className }) => {
  const users = getUsersFromIds(value, options)
  return <div className={className}>
    <div>
      {users.map((innerValue, index) => {
        return <div className="flex" style={{ marginBottom: 10 }} key={index}>
          <Select
            key={index}
            clearable={false}
            value={{ value: innerValue, label: innerValue && getDisplayName(innerValue) }}
            valueComponent={AvatarValue}
            onChange={(newValue) => {
              const newListOfUsers = users.set(index, newValue)
              onChange(setValuesGivenListOfUsers(newListOfUsers))
            }
            }
            placeholder="Select a Rep"
            options={_.values(options)}
            optionComponent={AvatarOption}
          />
          {index === 0
            ? <IconSVG src={plusIconSrc} onClick={() => onChange(value.push(''))} />
            : <IconSVG src={closeIconSrc} onClick={() => onChange(value.delete(index))} />}
        </div>
      }
      )}
    </div>
  </div>
}

export default RepSelectContainer



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/RepSelectContainer/component.js